import React, { useState } from "react";

const RequestDocumentModal = () => {
  const [formData, setFormData] = useState({
    documentType: "",
    purpose: "",
    urgency: "normal",
    deliveryMethod: "pickup",
    contactEmail: "",
    contactPhone: "",
    additionalNotes: "",
    quantity: 1,
  });

  const documentTypes = [
    {
      value: "transcript",
      label: "Official Transcript",
      fee: "$10",
      days: "3-5",
    },
    {
      value: "certificate",
      label: "Graduation Certificate",
      fee: "$15",
      days: "5-7",
    },
    {
      value: "enrollment",
      label: "Enrollment Verification",
      fee: "Free",
      days: "1-2",
    },
    {
      value: "conduct",
      label: "Character Certificate",
      fee: "$5",
      days: "2-3",
    },
    {
      value: "transfer",
      label: "Transfer Certificate",
      fee: "$20",
      days: "7-10",
    },
    {
      value: "recommendation",
      label: "Letter of Recommendation",
      fee: "$25",
      days: "5-10",
    },
  ];

  const purposeOptions = [
    "University Application",
    "Job Application",
    "Scholarship Application",
    "Visa/Immigration",
    "Personal Records",
    "Other",
  ];

  const handleSubmit = () => {
    // TODO: Submit document request API call
    console.log("Submitting document request:", formData);
  };

  const selectedDoc = documentTypes.find(
    (doc) => doc.value === formData.documentType
  );

  return (
    <div className="modal fade" id="requestDocumentModal">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">Request Official Document</h4>
            <button
              type="button"
              className="btn-close custom-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="modal-body">
            <form>
              <div className="row">
                <div className="col-md-8 mb-3">
                  <label className="form-label">
                    Document Type <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    value={formData.documentType}
                    onChange={(e) =>
                      setFormData({ ...formData, documentType: e.target.value })
                    }
                    required
                  >
                    <option value="">Select document type...</option>
                    {documentTypes.map((doc) => (
                      <option key={doc.value} value={doc.value}>
                        {doc.label} - {doc.fee} ({doc.days} business days)
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Quantity</label>
                  <input
                    type="number"
                    className="form-control"
                    min="1"
                    max="10"
                    value={formData.quantity}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        quantity: Number(e.target.value),
                      })
                    }
                  />
                </div>
              </div>

              {selectedDoc && (
                <div className="alert alert-info mb-3">
                  <div className="row">
                    <div className="col-md-4">
                      <strong>Processing Fee:</strong> {selectedDoc.fee}
                    </div>
                    <div className="col-md-4">
                      <strong>Processing Time:</strong> {selectedDoc.days} days
                    </div>
                    <div className="col-md-4">
                      <strong>Total Cost:</strong>{" "}
                      {selectedDoc.fee === "Free"
                        ? "Free"
                        : `$${
                            parseInt(selectedDoc.fee.replace("$", "")) *
                            formData.quantity
                          }`}
                    </div>
                  </div>
                </div>
              )}

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">
                    Purpose <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    value={formData.purpose}
                    onChange={(e) =>
                      setFormData({ ...formData, purpose: e.target.value })
                    }
                    required
                  >
                    <option value="">Select purpose...</option>
                    {purposeOptions.map((purpose) => (
                      <option key={purpose} value={purpose}>
                        {purpose}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Urgency</label>
                  <select
                    className="form-select"
                    value={formData.urgency}
                    onChange={(e) =>
                      setFormData({ ...formData, urgency: e.target.value })
                    }
                  >
                    <option value="normal">Normal Processing</option>
                    <option value="rush">Rush (+$10, 1-2 days)</option>
                    <option value="express">Express (+$25, Same day)</option>
                  </select>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Delivery Method</label>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="deliveryMethod"
                        value="pickup"
                        checked={formData.deliveryMethod === "pickup"}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            deliveryMethod: e.target.value,
                          })
                        }
                      />
                      <label className="form-check-label">
                        <strong>Office Pickup</strong>
                        <br />
                        <small className="text-muted">
                          Free - Pick up from Student Services
                        </small>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="deliveryMethod"
                        value="mail"
                        checked={formData.deliveryMethod === "mail"}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            deliveryMethod: e.target.value,
                          })
                        }
                      />
                      <label className="form-check-label">
                        <strong>Mail Delivery</strong>
                        <br />
                        <small className="text-muted">
                          +$5 - Delivered to address
                        </small>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="deliveryMethod"
                        value="email"
                        checked={formData.deliveryMethod === "email"}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            deliveryMethod: e.target.value,
                          })
                        }
                      />
                      <label className="form-check-label">
                        <strong>Digital Copy</strong>
                        <br />
                        <small className="text-muted">
                          Free - PDF via email
                        </small>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">
                    Contact Email <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    value={formData.contactEmail}
                    onChange={(e) =>
                      setFormData({ ...formData, contactEmail: e.target.value })
                    }
                    placeholder="your.email@example.com"
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Contact Phone</label>
                  <input
                    type="tel"
                    className="form-control"
                    value={formData.contactPhone}
                    onChange={(e) =>
                      setFormData({ ...formData, contactPhone: e.target.value })
                    }
                    placeholder="+1 (555) 123-4567"
                  />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Additional Notes</label>
                <textarea
                  className="form-control"
                  rows={3}
                  placeholder="Any special instructions or additional information..."
                  value={formData.additionalNotes}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      additionalNotes: e.target.value,
                    })
                  }
                ></textarea>
              </div>

              <div className="alert alert-warning">
                <h6>
                  <i className="ti ti-info-circle me-2"></i>Important Notes:
                </h6>
                <ul className="mb-0">
                  <li>All requests must be verified before processing</li>
                  <li>Processing times are business days only</li>
                  <li>Rush/Express fees are non-refundable</li>
                  <li>You will receive email confirmation once submitted</li>
                </ul>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light me-2"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={
                !formData.documentType ||
                !formData.purpose ||
                !formData.contactEmail
              }
            >
              <i className="ti ti-send me-2"></i>Submit Request
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestDocumentModal;
